<template>
  <div class="personal-center">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>个人中心</h1>
      <p>管理您的权益和词库设置</p>
    </div>

    <!-- 我的权益 -->
    <el-card class="section-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="section-title">我的权益（0点清零）</span>
      </div>
      <div class="rights-container">
        <div class="rights-grid">
          <!-- AI写作次数 -->
          <div class="rights-item" v-for="(item,index) in equityList" :key="index">
            <div class="rights-icon">
              <i class="el-icon-edit"></i>
            </div>
            <div class="rights-content">
              <h3>{{ item.type }}</h3>
              <div class="progress-info">
                <span class="usage-text">已使用 {{ item.count }} / {{ item.total }} 次</span>
                <el-progress 
                  :percentage="percentage(item.count,item.total)" 
                  :color="getProgressColor(item.count,item.total)"
                  :show-text="false">
                </el-progress>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 我的词库 -->
    <el-card class="section-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="section-title">我的词库</span>
        <el-button 
          type="primary" 
          size="small" 
          icon="el-icon-plus"
          style="float: right; padding: 3px 15px"
          @click="showAddDialog = true">
          添加词条
        </el-button>
      </div>
      
      <!-- 搜索和过滤 -->
      <div class="dictionary-controls">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索词条..."
          prefix-icon="el-icon-search"
          clearable
          style="width: 300px; margin-right: 20px;">
        </el-input>
        <el-select v-model="selectedCategory" placeholder="选择分类" clearable style="width: 150px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="正词" value="正词"></el-option>
            <el-option label="错词" value="错词"></el-option>
        </el-select>
      </div>

      <!-- 词库列表 -->
      <el-table 
        :data="filteredDictionary" 
        style="width: 100%; margin-top: 20px;"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column prop="content" label="词条" >
          <template slot-scope="scope">
            <span class="word-text">{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="correct_content" label="校正为" >
          <template slot-scope="scope">
            <span class="correction-text">{{ scope.row.correct_content ? scope.row.correct_content : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="category" label="分类" >
          <template slot-scope="scope">
            <el-tag size="small" :type="getCategoryType(scope.row.type_text)">
              {{ scope.row.type_text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createtime_text" label="创建时间" >
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button 
              type="text" 
              size="small" 
              @click="editDictionary(scope.row)"
              style="color: #409eff;">
              编辑
            </el-button>
            <el-button 
              type="text" 
              size="small" 
              @click="deleteDictionary(scope.$index)"
              style="color: #f56c6c;">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="filteredDictionary.length">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加/编辑词条对话框 -->
    <el-dialog 
      :title="isEdit ? '编辑词条' : '添加词条'" 
      :visible.sync="showAddDialog"
      width="500px"
      @close="resetForm">
      <el-form :model="dictionaryForm" :rules="formRules" ref="dictionaryForm" label-width="80px">
        <el-form-item label="分类" prop="type">
          <el-select v-model="dictionaryForm.type" placeholder="选择分类" style="width: 100%;" @change="handleTypeChange">
            <el-option label="正词" :value="0"></el-option>
            <el-option label="错词" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="词条" prop="content">
          <el-input v-model="dictionaryForm.content" placeholder="请输入要校正的词条"></el-input>
        </el-form-item>
        <el-form-item label="校正为" prop="correct_content" :required="dictionaryForm.type == 1" v-if="dictionaryForm.type == 1">
          <el-input v-model="dictionaryForm.correct_content" placeholder="请输入校正后的内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveDictionary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PersonalCenter',
  data() {
    return {
      loading: false,
      equityList:[],

      // 词库相关数据
      dictionary: [],
      searchKeyword: '',
      selectedCategory: '',
      currentPage: 1,
      pageSize: 10,

      // 对话框相关
      showAddDialog: false,
      isEdit: false,
      editIndex: -1,
      dictionaryForm: {
        content: '',
        correct_content: '',
        type: ''
      },
      formRules: {
        type: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入词条', trigger: 'blur' }
        ],
        correct_content: [
          {
            validator: (rule, value, callback) => {
              // this 指向 Vue 实例，所以要用箭头函数
              if (this.dictionaryForm.type === 1 && (!value || value.trim() === '')) {
                callback(new Error('请输入校正内容'))
              } else {
                callback() // 验证通过
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    
    // 过滤后的词库
    filteredDictionary() {
      let filtered = this.dictionary
      
      // 按关键词搜索
      if (this.searchKeyword) {
        filtered = filtered.filter(item => 
          item.content.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
          item.correct_content.toLowerCase().includes(this.searchKeyword.toLowerCase())
        )
      }
      
      // 按分类过滤
      if (this.selectedCategory) {
        filtered = filtered.filter(item => item.type_text === this.selectedCategory)
      }
      
      return filtered
    }
  },
  created(){
    this.equity()
    this.lexicon()
  },
  methods: {
    handleTypeChange() {
      // 重新校验 correct_content
      this.$refs.dictionaryForm.validateField('correct_content')
    },
    async lexicon(){
      this.loading = true
      try {
        // 调用后端接口
        const res = await this.$api.post('/api/user/lexiconList', {})
        this.dictionary = res.data.data;
      } catch (err) {
        console.error('获取失败:', err)
        this.$message.error(err.message || '数据获取失败')
      } finally {
        this.loading = false
      }
    },
    // 计算权益使用百分比
    percentage(count, total) {
      count = Number(count) || 0;
      total = Number(total) || 0;

      if (total === 0) return 0;  // 防止除零
      let percent = (count / total) * 100;

      // 保证百分比在 0~100 之间
      percent = Math.max(0, Math.min(100, percent));

      return percent;
    },
    async equity(){
      this.loading = true
        try {
          // 调用后端接口
          const res = await this.$api.post('/api/user/equity', {})
          this.equityList = res.data;
        } catch (err) {
          console.error('获取失败:', err)
          this.$message.error(err.message || '数据获取失败')
        } finally {
          this.loading = false
        }
    },
    
    // 获取进度条颜色
    getProgressColor(count,total) {
      const num = this.percentage(count,total);
      if (num < 50) return '#67c23a'
      if (num < 80) return '#e6a23c'
      return '#f56c6c'
    },
    
    // 获取分类标签类型
    getCategoryType(category) {
      const typeMap = {
        '正词': '0',
        '错词': '1'
      }
      return typeMap[category] || ''
    },
    
    // 编辑词条
    editDictionary(row) {
      this.isEdit = true
      this.editIndex = this.dictionary.findIndex(item => item.id === row.id)
      this.dictionaryForm = {
        id:row.id,
        content: row.content,
        correct_content: row.correct_content,
        type: row.type
      }
      this.showAddDialog = true
    },
    
    // 删除词条
    deleteDictionary(index) {
      this.$confirm('确认删除这个词条吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dictionary.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    
    // 保存词条
    async saveDictionary() {
      this.loading = true
      try {
        const valid = await this.$refs.dictionaryForm.validate()
        if (!valid) {
          this.loading = false
          return
        }

        if (this.isEdit) {
          const item = this.dictionaryForm
          const res = await this.$api.post('/api/user/lexiconEdit', item)
          this.$message.success('词条更新成功!')
          await this.lexicon()
        } else {
          if (this.dictionaryForm.type == 1 && !this.dictionaryForm.correct_content) {
            this.$message.error('请填写校正内容')
            this.loading = false
            return
          }

          const newItem = {
            content: this.dictionaryForm.content,
            correct_content:
              this.dictionaryForm.type == 0 ? '' : this.dictionaryForm.correct_content,
            type: this.dictionaryForm.type,
          }

          const res = await this.$api.post('/api/user/lexiconAdd', newItem)
          this.$message.success('词条添加成功!')
          await this.lexicon()
        }

        this.showAddDialog = false
        this.resetForm()
      } catch (err) {
        console.error('保存失败:', err)
        this.$message.error(err.msg || '保存失败')
      } finally {
        this.loading = false
      }
    },

    
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.editIndex = -1
      this.dictionaryForm = {
        content: '',
        correct_content: '',
        type: ''
      }
      if (this.$refs.dictionaryForm) {
        this.$refs.dictionaryForm.resetFields()
      }
    },
    
    // 分页处理
    handleCurrentChange(page) {
      this.currentPage = page
    }
  }
}
</script>

<style scoped>
.personal-center {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px 0;
}

.page-header h1 {
  font-size: 28px;
  color: #303133;
  margin: 0 0 10px 0;
  font-weight: 600;
}

.page-header p {
  color: #909399;
  font-size: 14px;
  margin: 0;
}

.section-card {
  margin-bottom: 30px;
  border-radius: 8px;
  border: none;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

/* 权益样式 */
.rights-container {
  padding: 10px 0;
}

.rights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.rights-item {
  display: flex;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #fafbff 100%);
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
}

.rights-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.rights-icon {
  margin-right: 15px;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #409eff, #66b1ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.rights-content {
  flex: 1;
}

.rights-content h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}

.progress-info {
  width: 100%;
}

.usage-text {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  display: block;
}

/* 词库样式 */
.dictionary-controls {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.word-text {
  font-weight: 600;
  color: #f56c6c;
}

.correction-text {
  font-weight: 600;
  color: #67c23a;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .personal-center {
    padding: 15px;
  }
  
  .rights-grid {
    grid-template-columns: 1fr;
  }
  
  .dictionary-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .dictionary-controls .el-input {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
  
  .dictionary-controls .el-select {
    width: 100% !important;
  }
}

/* Element UI 样式覆盖 */
.el-card__header {
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
}

.el-progress-bar__outer {
  background-color: #ebeef5;
  border-radius: 10px;
  height: 8px;
}

.el-progress-bar__inner {
  border-radius: 10px;
}

.el-table th {
  font-weight: 600;
}

.el-tag {
  border-radius: 12px;
}
</style>